<template>
  <b-container>
    <div v-for="collection_name of collection_names_ordered" :key="collection_name" class="mb-4">
      <b-row>
        <b-col>
          <h3>{{collection_name | capitalise}}</h3>
        </b-col>
        <b-col>
          <b-button class="float-right" size="sm" variant="primary" @click="entry_create(site.collections[collection_name])">Add</b-button>
          <b-button class="mr-2 float-right" v-if="site.collections[collection_name].template" size="sm" @click="go_to_entry(site.collections[collection_name].template)">Edit Template</b-button>
        </b-col>
      </b-row>

      <draggable v-model="site.collections[collection_name].entries" handle=".handle" @end="update_collections(collection_name)">
        <transition-group>
          <b-card v-for="(item, entry_index) of site.collections[collection_name].entries" :key="item.id + entry_index" class="card-select mt-2" @click="go_to_entry(item)">
            <b-card-text>
              {{item.name}}
              <b-badge v-for="(entry_type, $index) of item.types" :key="item.id + $index" class="mr-2">{{entry_type}}</b-badge>
              <b-badge v-if="item.status == 'draft'" class="mr-2" variant="warning">draft</b-badge>
              <b-button class="handle float-right" size="sm"><i class="fas fa-grip-vertical"></i></b-button>
              <b-button class="handle float-right mr-2" size="sm" @click="$evt => go_to_entry(item, undefined, 'settings', $evt)"><i class="fad fa-cog"></i></b-button>
            </b-card-text>
          </b-card>
        </transition-group>
      </draggable>

      <b-card class="mt-2 text-center" v-if="site.collections[collection_name].entries.length === 0">
        <b-card-text>
          No {{collection_name}} here yet.
        </b-card-text>
        <b-button @click="entry_create(site.collections[collection_name])">Create the first</b-button>
      </b-card>

      <!-- <div v-if="collection_name === 'services'">
        <b-row class="mt-4">
          <b-col>
            <h3>Folders</h3>
          </b-col>
          <b-col>
            <b-button class="float-right" size="sm" variant="primary" @click="folder_create(site.collections[collection_name])">Add</b-button>
          </b-col>
        </b-row>
        <b-card v-for="folder of site.collections[collection_name].folders" :key="folder" class="mt-2">
          <b-card-text>
            {{folder}}
            <b-button class="handle float-right" variant="danger" size="sm" @click="folder_delete(site.collections[collection_name], folder)">Delete</b-button>
          </b-card-text>
        </b-card>
      </div> -->
    </div>
  </b-container>
</template>

<script>

import { db, serverTimestamp, FieldValue } from '@/main.js'
import ItemMixin from '@/mixins/Item.js'
import EntryMixin from '@/mixins/Entry.js'
import draggable from 'vuedraggable'


export default {
  name: 'entries',
  mixins: [ItemMixin, EntryMixin],
  props: ['site', 'user', 'profile'],
  components: {draggable},
  firestore: function () {
    return {
      items: db.collection('site').doc(this.$route.params.site_id).collection(this.collection).orderBy('created', 'desc')
    }
  },
  data() {
    return {
      items: [],
      is_creating: false,
      collection: 'entry'
    }
  },
  computed: {
    collection_names_ordered() {
      if (this.$route.meta.entry_type) {
        return [this.$route.meta.entry_type]
      }

      return ['singles', 'services', 'blogs', 'awards', 'testimonials']
    }
  },
  methods: {
    async update_collections(name) {
      let update = {}
      update[`collections.${name}.entries`] = this.site.collections[name].entries
      await db.collection('site').doc(this.$route.params.site_id).update(update)
      await db.collection('deploy_queue').doc(this.site.id).set({updated: serverTimestamp(), update_count: FieldValue.increment(1)}, {merge: true})
    },
    async folder_create(collection) {
      let result = await this.$swal({
        title: 'folder name',
        input: 'text',
        showCancelButton: true,
      })

      if (!result || !result.value) {
        return
      }

      let update = {}
      update[`collections.${collection.name}.folders`] = FieldValue.arrayUnion(result.value)
      await db.collection('site').doc(this.$route.params.site_id).update(update)
    },
    async folder_delete(collection, folder) {
      let update = {}
      update[`collections.${collection.name}.folders`] = FieldValue.arrayRemove(folder)
      await db.collection('site').doc(this.$route.params.site_id).update(update)

      // TODO update existing blocks?
    },
  },
  metaInfo() {
    return {
      title: `${this.collection}s`
    };
  },
}
</script>

<style scoped>

.card-select {
  cursor: pointer;
}

.card-select:hover {
  background-color: #EEE;
}

</style>
